import {
  AbcIcon,
  BeakerIcon,
  bioquimicaIcon,
  CalculatorIcon,
  ContractIcon,
  CornerstoneIcon,
  DnaIcon,
  embriologiaIcon,
  EnglishIcon,
  farmacologiaIcon,
  fisiologiaIcon,
  geneticaIcon,
  GlobeIcon,
  histologiaIcon,
  imunologiaIcon,
  IntersectionIcon,
  microbiologiaIcon,
  MoleculeIcon,
  OwlIcon,
  parasitologiaIcon,
  patologiaIcon,
  PencilIcon,
  SpanishIcon,
  TempleIcon,
} from 'morpheus-ui';
import { Permissions } from '../accessControl/permissions';
import { anatomiaIcon } from '../components/atoms/AnatomiaIcon';

export const knowledgeDisciplineSlugs = [
  'linguagens-codigos-e-suas-tecnologias',
  'ciencias-humanas-e-suas-tecnologias',
  'ciencias-da-natureza-e-suas-tecnologias',
  'matematica-e-suas-tecnologias',
];

export const disciplinesWithKnowledge: { [key: string]: string } = {
  biologia: 'ciencias-da-natureza-e-suas-tecnologias',
  fisica: 'ciencias-da-natureza-e-suas-tecnologias',
  quimica: 'ciencias-da-natureza-e-suas-tecnologias',
  matematica: 'matematica-e-suas-tecnologias',
  historia: 'ciencias-humanas-e-suas-tecnologias',
  geografia: 'ciencias-humanas-e-suas-tecnologias',
  filosofia: 'ciencias-humanas-e-suas-tecnologias',
  sociologia: 'ciencias-humanas-e-suas-tecnologias',
  portugues: 'linguagens-codigos-e-suas-tecnologias',
  literatura: 'linguagens-codigos-e-suas-tecnologias',
  ingles: 'linguagens-codigos-e-suas-tecnologias',
  espanhol: 'linguagens-codigos-e-suas-tecnologias',
  interdisciplinar: 'interdisciplinar',
};

export const getKnowledgeDisciplineName = (knowledgeAreaSlug: string) => {
  switch (knowledgeAreaSlug) {
    case 'linguagens-codigos-e-suas-tecnologias':
      return 'Linguagens';
    case 'ciencias-humanas-e-suas-tecnologias':
      return 'Ciências Humanas';
    case 'ciencias-da-natureza-e-suas-tecnologias':
      return 'Ciências da Natureza';
    case 'matematica-e-suas-tecnologias':
      return 'Matemática';
  }
};

export const getDisciplineIcon = (discipline: string) => {
  switch (discipline) {
    case 'biologia':
      return DnaIcon;
    case 'química':
      return BeakerIcon;
    case 'física':
      return MoleculeIcon;
    case 'matemática':
      return CalculatorIcon;
    case 'história':
      return CornerstoneIcon;
    case 'geografia':
      return GlobeIcon;
    case 'filosofia':
      return OwlIcon;
    case 'sociologia':
      return TempleIcon;
    case 'português':
      return PencilIcon;
    case 'literatura':
      return AbcIcon;
    case 'inglês':
      return EnglishIcon;
    case 'espanhol':
      return SpanishIcon;
    case 'interdisciplinar':
      return IntersectionIcon;
    case 'quimica':
      return BeakerIcon;
    case 'fisica':
      return MoleculeIcon;
    case 'matematica':
      return CalculatorIcon;
    case 'historia':
      return CornerstoneIcon;
    case 'portugues':
      return PencilIcon;
    case 'ingles':
      return EnglishIcon;
    case 'redacao':
      return PencilIcon;
    case 'atualidades':
      return ContractIcon;
    case 'bioquimica-superior':
      return bioquimicaIcon;
    case 'anatomia-superior':
      return anatomiaIcon;
    case 'histologia-humana-superior':
      return histologiaIcon;
    case 'fisiologia-superior':
      return fisiologiaIcon;
    case 'genetica-superior':
      return geneticaIcon;
    case 'embriologia-superior':
      return embriologiaIcon;
    case 'imunologia-superior':
      return imunologiaIcon;
    case 'microbiologia-superior':
      return microbiologiaIcon;
    case 'parasitologia-superior':
      return parasitologiaIcon;
    case 'patologia-superior':
      return patologiaIcon;
    case 'farmacologia-superior':
      return farmacologiaIcon;
    default:
      return DnaIcon;
  }
};

// Disciplinas do Universitário, gerenciadas pelo mesmo sistema de permissões
// (Permissions.DISCIPLINAS_*) que já controla a visibilidade dos itens de menu.
export const getUniversitarioDisciplinePermission = (
  disciplineSlug: string,
): Permissions | undefined => {
  switch (disciplineSlug) {
    case 'bioquimica-superior':
      return Permissions.DISCIPLINAS_BIOQUIMICA;
    case 'anatomia-superior':
      return Permissions.DISCIPLINAS_ANATOMIA;
    case 'histologia-humana-superior':
      return Permissions.DISCIPLINAS_HISTOLOGIA;
    case 'fisiologia-superior':
      return Permissions.DISCIPLINAS_FISIOLOGIA;
    case 'genetica-superior':
      return Permissions.DISCIPLINAS_GENETICA;
    case 'embriologia-superior':
      return Permissions.DISCIPLINAS_EMBRIOLOGIA;
    case 'imunologia-superior':
      return Permissions.DISCIPLINAS_IMUNOLOGIA;
    case 'microbiologia-superior':
      return Permissions.DISCIPLINAS_MICROBIOLOGIA;
    case 'parasitologia-superior':
      return Permissions.DISCIPLINAS_PARASITOLOGIA;
    case 'patologia-superior':
      return Permissions.DISCIPLINAS_PATOLOGIA;
    case 'farmacologia-superior':
      return Permissions.DISCIPLINAS_FARMACOLOGIA;
    default:
      return undefined;
  }
};

export const getDisciplineName = (disciplineSlug: string) => {
  switch (disciplineSlug) {
    case 'biologia':
      return 'Biologia';
    case 'filosofia':
      return 'Filosofia';
    case 'geografia':
      return 'Geografia';
    case 'redacao':
      return 'Redação';
    case 'sociologia':
      return 'Sociologia';
    case 'quimica':
      return 'Química';
    case 'espanhol':
      return 'Espanhol';
    case 'fisica':
      return 'Física';
    case 'historia':
      return 'História';
    case 'ingles':
      return 'Inglês';
    case 'literatura':
      return 'Literatura';
    case 'matematica':
      return 'Matemática';
    case 'portugues':
      return 'Português';
    case 'interdisciplinar':
      return 'Interdisciplinar';
    case 'bioquimica-superior':
      return 'Bioquímica';
    case 'anatomia-superior':
      return 'Anatomia Humana';
    case 'histologia-humana-superior':
      return 'Histologia Humana';
    case 'fisiologia-superior':
      return 'Fisiologia Humana';
    case 'genetica-superior':
      return 'Genética';
    case 'embriologia-superior':
      return 'Embriologia';
    case 'imunologia-superior':
      return 'Imunologia';
    case 'microbiologia-superior':
      return 'Microbiologia';
    case 'parasitologia-superior':
      return 'Parasitologia';
    case 'patologia-superior':
      return 'Patologia';
    case 'farmacologia-superior':
      return 'Farmacologia';
    case 'lesson':
      return 'Videoaula';
    case 'exercise':
      return 'Exercício';
    case 'mapamental':
      return 'Mapa mental';
    case 'mindmap':
      return 'Mapa mental';
    case 'apostila':
      return 'Apostila';
    case 'workbook':
      return 'Apostila';
    case 'audio':
      return 'Podcast';
    case 'podcast':
      return 'Podcast';
    case 'live':
      return 'Live';
    case 'gramatica':
      return 'Gramática';
    case 'atualidades':
      return 'Atualidades';
    default:
      return disciplineSlug;
  }
};

export function getDisciplineSlugByName(name: string) {
  switch (name) {
    case 'Biologia':
      return 'biologia';
    case 'Filosofia':
      return 'filosofia';
    case 'Geografia':
      return 'geografia';
    case 'Redação':
      return 'redacao';
    case 'Sociologia':
      return 'sociologia';
    case 'Química':
      return 'quimica';
    case 'Espanhol':
      return 'espanhol';
    case 'Física':
      return 'fisica';
    case 'História':
      return 'historia';
    case 'Inglês':
      return 'ingles';
    case 'Literatura':
      return 'literatura';
    case 'Matemática':
      return 'matematica';
    case 'Português':
      return 'portugues';
    case 'Interdisciplinar':
      return 'interdisciplinar';
    case 'Videoaula':
      return 'lesson';
    case 'Exercício':
      return 'exercise';
    case 'Mapa mental':
      return 'mapamental';
    case 'Apostila':
      return 'apostila';
    case 'Podcast':
      return 'audio';
    case 'Live':
      return 'live';
    case 'Gramática':
      return 'gramatica';
    case 'Atualidades':
      return 'atualidades';
    default:
      return name;
  }
}

export const getPortugueseDisciplineSlug = (disciplineSlug: string) => {
  switch (disciplineSlug) {
    case '':
      return 'interdisciplinar';
    case 'biology':
      return 'biologia';
    case 'physical':
      return 'fisica';
    case 'chemistry':
      return 'quimica';
    case 'mathematics':
      return 'matematica';
    case 'history':
      return 'historia';
    case 'geography':
      return 'geografia';
    case 'philosophy':
      return 'filosofia';
    case 'sociology':
      return 'sociologia';
    case 'portuguese':
      return 'portugues';
    case 'literature':
      return 'literatura';
    case 'english':
      return 'ingles';
    case 'spanish':
      return 'espanhol';
    default:
      return disciplineSlug;
  }
};
